module.exports = __webpack_public_path__ + "img/lang-de-hover.1eda50da.png";